import { render, staticRenderFns } from "./FullLoader.vue?vue&type=template&id=878f5b50&scoped=true&"
import script from "./FullLoader.vue?vue&type=script&lang=js&"
export * from "./FullLoader.vue?vue&type=script&lang=js&"
import style0 from "./FullLoader.vue?vue&type=style&index=0&id=878f5b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878f5b50",
  null
  
)

export default component.exports